

<app-calculation-box [status]="calculationStatus()" [loading]="calculationRx.isLoading()">

    <div>{{display().table}} {{display().baseCurrent}}</div>
    <div>{{display().sustainedCurrent}}</div>

    @if(display().suggestedCableShow) {
    <div>{{display().suggestedCable}}</div>
    }

    @if(display().deratingFactorsShow) {
    <div class="flex">
        <div>Derating Factors:</div>
        <div>
            @for(factor of display().deratingFactors; track factor.reference) {
            <div class="ml-4">{{factor.reference}}: {{factor.value}}</div>
            }
        </div>
    </div>
    }

    <div>{{display().conductorTemperature}}</div>

    @if(display().showUDRNote) {
    <div class="pt-2">
        <b>UDR</b> allows you to enter a known sustained current rating for documentation and downstream calculations. To calculate the sustained rating for your cable or determine the CSA to use, please select a sizing standard from the 'Sizing Standard' dropdown.

    </div>
    }

</app-calculation-box>

